import API from "serviceshift-ui/api-client";

export default {
  async fetchClockedInStatus({ dispatch }) {
    try {
      const res = await API.makeRequest("/admin/v4/time_cards/status", {
        method: "GET"
      });
      if (res.data) {
        dispatch("updateCurrentAdmin", {
          clockedIn: res.data.is_clocked_in,
          clockedInAt: res.data.created_at
        });
      }
    } catch (e) {
      console.error(e);
    }
  },
  async clockIn({ dispatch }) {
    try {
      const res = await API.makeRequest("/admin/v4/time_cards/clock_in", {
        method: "POST"
      });
      if (res.data) {
        dispatch("updateCurrentAdmin", { clockedIn: res.data.is_open });
      }
    } catch (e) {
      console.error(e);
    }
  },
  async clockOut({ dispatch }) {
    try {
      const res = await API.makeRequest("/admin/v4/time_cards/clock_out", {
        method: "PUT"
      });
      if (res.data) {
        dispatch("updateCurrentAdmin", { clockedIn: res.data.is_open });
      }
    } catch (e) {
      console.error(e);
    }
  },
  updateCurrentAdmin({ commit }, data) {
    commit("update", {
      state: "currentAdmin",
      data
    });
  },
  setCurrentAdmin({ commit }, data) {
    commit("replace", {
      state: "currentAdmin",
      data
    });
  }
};
